import { PageHeader, withHTMLHeadSEO } from 'components/common';
import CaseSimulationCommonLanding from 'components/common/case-simulation-common-landing/CaseSimulationCommonLanding';

const SimulationEhrLandingPage = () => (
  <div>
    <PageHeader title="SimChart Assignment" />
    <CaseSimulationCommonLanding />
  </div>
);

export { SimulationEhrLandingPage as BaseSimulationEhrLandingPage };
export default withHTMLHeadSEO({ title: 'Simulation EHR Landing Page' })(SimulationEhrLandingPage);
